import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Droppable, Draggable } from "@hello-pangea/dnd";
import { OffensivePlaybookPlay } from "../../../types/SchemesTypes";

interface SituationPlaysTableProps {
  plays: OffensivePlaybookPlay[];
  droppableId: string;
}

const SituationPlaysTable: React.FC<SituationPlaysTableProps> = ({ plays, droppableId }) => {
  return (
    <Droppable droppableId={droppableId}>
      {(provided) => (
        <Table
          component={Paper}
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          <TableHead>
            <TableRow>
            <TableCell>Personnel</TableCell>
            <TableCell>Formation</TableCell>
            <TableCell>Code Word</TableCell>
            <TableCell>Concept</TableCell>
              {/* Add more columns as needed */}
            </TableRow>
          </TableHead>
          <TableBody>
            {plays.map((play, idx) => (
              <Draggable
                key={play.code_word + idx}
                draggableId={play.code_word + idx}
                index={idx}
              >
                {(provided) => (
                  <TableRow
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <TableCell>{play.play_details?.personnel_group_name}</TableCell>
                    <TableCell>{play.play_details?.code_word}</TableCell>
                    <TableCell>{play.play_details?.concept_name}</TableCell>
                    <TableCell>{play.play_details?.formation_name}</TableCell>
                    {/* Add more cells as needed */}
                  </TableRow>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </TableBody>
        </Table>
      )}
    </Droppable>
  );
};

export default SituationPlaysTable; 